export const VNWEBSDK_SET_DATA_RECIEVE = 'VNWEBSDK_SET_DATA_RECIEVE'
